export var VideoSizeMode;
(function (VideoSizeMode) {
    VideoSizeMode["Fit"] = "fit";
    // "fill" is the new name for "crop"
    VideoSizeMode["Fill"] = "crop";
})(VideoSizeMode || (VideoSizeMode = {}));
